import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";

import { PAGE_URL } from "./value/Url";
import LoginMainPage from "./components/login/LoginMainPage";
import NotFound from "./components/error/NotFound";
import MainPageContainer from "./components/MainPageContainer";

function App() {
    return (
        <Router>
            <Routes>
                <Route path={`${PAGE_URL.LOGIN}/*`} element={<LoginMainPage/>}/>
                <Route path={`/*`} element={<MainPageContainer/>}/>
                <Route path='*' element={<NotFound/>}/>
            </Routes>
        </Router>
    );
}

export default App;
